interface LotQtySource {
	quantity?: number | null;
	lot_total_quantity?: number | null;
}

/** Total-quantity value for the Manual inspection header pill.
 *  For Swiss lots the backend supplies lot_total_quantity (sum across batches);
 *  otherwise fall back to the line item's own quantity. */
export function getTotalQtyDisplay(
	orderLineItem: LotQtySource | undefined | null
): number | undefined {
	if (!orderLineItem) return undefined;
	const lot = orderLineItem.lot_total_quantity;
	if (lot !== undefined && lot !== null) return lot;
	return orderLineItem.quantity ?? undefined;
}
